import { render, staticRenderFns } from "./AddOrganizationPopup.vue?vue&type=template&id=98016fc8&scoped=true"
import script from "./AddOrganizationPopup.vue?vue&type=script&lang=js"
export * from "./AddOrganizationPopup.vue?vue&type=script&lang=js"
import style0 from "./AddOrganizationPopup.vue?vue&type=style&index=0&id=98016fc8&prod&lang=scss"
import style1 from "./AddOrganizationPopup.vue?vue&type=style&index=1&id=98016fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98016fc8",
  null
  
)

export default component.exports